
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonMobileRT(): TemplateResult<dialogButtonMobileRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('svg', {
                'className': 'icon-search-ok',
                'viewBox': '0 0 31 32'
            }, _createElement('path', { 'd': 'M14.080 5.565c-4.948 0-8.96 4.012-8.96 8.96s4.012 8.96 8.96 8.96 8.96-4.012 8.96-8.96c0-4.948-4.012-8.96-8.96-8.96zM2.56 14.525c0-6.362 5.158-11.52 11.52-11.52s11.52 5.158 11.52 11.52c0 6.362-5.158 11.52-11.52 11.52s-11.52-5.158-11.52-11.52z' }), _createElement('path', { 'd': 'M20.407 20.852c0.5-0.5 1.31-0.5 1.81 0l5.568 5.568c0.5 0.5 0.5 1.31 0 1.81s-1.31 0.5-1.81 0l-5.568-5.568c-0.5-0.5-0.5-1.31 0-1.81z' })), _createElement('span', { 'className': 'sr-only' }, 'Search'));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]